module.exports = __webpack_public_path__ + "img/logo.84ed9025.svg";